import useTranslation from "hooks/useTranslation"
import { useNavigate } from "react-router-dom"
import { useAuth } from "contexts/AuthContext"
import Button from "components/Button"
import Modal from "./Modal"

interface LoginRequiredModalProps {
  onClose: () => void
  addGuestLoginOption?: boolean
  customRedirect?: auth.Redirect
  previousLocation?: string
  previousPage?: boolean
  isHistory?: boolean
}

const LoginRequiredModal: React.FC<LoginRequiredModalProps> = ({ isHistory, previousLocation, customRedirect, previousPage, addGuestLoginOption, onClose }) => {
  const { t } = useTranslation('loginmodal')
  const navigate = useNavigate()
  const auth = useAuth()

  const handleLogin = () => {
    auth.saveRedirectPage(customRedirect?.pathname || window.location.pathname, customRedirect?.state)
    navigate(`/login`)
    onClose()
  }

  const handleLoginAsGuest = () => {
    auth.setUserAsGuest(true)
    onClose()
  }

  const handleBack = () => {
    if (previousLocation) {
      navigate(previousLocation)
    } else if (previousPage) {
      navigate(-1)
    }
    onClose()
  }

  return (
    <Modal
      isHistory={isHistory}
      onClose={onClose}
      title={t('login_prompt')}
      topSubtitle={t('required_action')}>
      <div className="modal__fromQr">
        <h2>{t('choose_action')}</h2>
        <Button type='primary' text={t('go_to_login')} action={handleLogin} />
        {addGuestLoginOption
          ? <Button type='secondary' text={t('continue_as_guest')} action={handleLoginAsGuest} />
          : <Button type='secondary' text={t('cancel')} action={handleBack} />}
      </div>
    </Modal>)
}

export default LoginRequiredModal